import * as eff from 'redux-saga/effects';
import createActionCreators from 'redux-resource-action-creators';

import {
  actionTypes,
} from '../actions';
import {
  throwError,
} from './helpers';
import api from '../api';

export default function* videoFlow() {
  function* getVideos({ params, list }) {
    const actions = createActionCreators('read', {
      resourceType: 'videos',
      requestKey: 'fetchVideos',
    });

    try {
      yield eff.put(actions.pending());
      const results = yield eff.call(
        api.getVideos,
        {
          qs: params,
        },
      );

      const meta = results[0];

      const resources = Array.isArray(results[1]) ? results[1] : results;

      yield eff.put(actions.succeeded({
        resources,
        list,
        mergeListIds: false,
        requestProperties: {
          meta,
        },
      }));
    } catch (e) {
      yield eff.put(actions.failed({
        resources: [],
      }));

      yield eff.call(throwError, e);
    }
  }

  function* searchVideos({ params }) {
    const actions = createActionCreators('read', {
      resourceType: 'videos',
      requestKey: 'searchVideos',
    });

    try {
      yield eff.put(actions.pending());

      const results = yield eff.call(
        api.searchVideo,
        {
          qs: params,
        },
      );

      const meta = results[0];

      const resources = Array.isArray(results[1]) ? results[1] : results;

      const action = (resources.length > 0) ? actions.succeeded : actions.failed;

      yield eff.put(action({
        resources,
        multiLists: {
          videos: {
            searchResults: resources.map(v => v.id),
          },
        },
        requestProperties: {
          meta,
        },
      }));
    } catch (e) {
      yield eff.put(actions.failed({
        resources: [],
      }));

      yield eff.call(throwError, e);
    }
  }

  yield eff.takeEvery(actionTypes.REQUEST_GET_VIDEOS, getVideos);
  yield eff.takeEvery(actionTypes.REQUEST_SEARCH_VIDEO, searchVideos);
}
